import React from 'react';
import { ArrowDownRight, ArrowUpRight, DollarSign, Wallet } from 'lucide-react';
import { Card, CardContent, CardHeader, CardTitle } from '../components/ui/Card';
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from '../components/ui/Table';
import { mockTransactions } from '../data/mockData';
import { formatCurrency, formatDate } from '../lib/utils';
import { Badge } from '../components/ui/Badge';
export function Financial() {
  const income = mockTransactions.filter(t => t.type === 'income').reduce((acc, curr) => acc + curr.amount, 0);
  const expense = mockTransactions.filter(t => t.type === 'expense').reduce((acc, curr) => acc + curr.amount, 0);
  const balance = income - expense;
  return <div className="h-full flex flex-col space-y-6" data-id="element-486">
      <div data-id="element-487">
        <h1 className="text-3xl font-heading font-bold tracking-tight" data-id="element-488">
          Financeiro
        </h1>
        <p className="text-muted-foreground mt-1" data-id="element-489">
          Gestão de caixa e pagamentos.
        </p>
      </div>

      <div className="grid gap-4 md:grid-cols-3" data-id="element-490">
        <Card data-id="element-491">
          <CardHeader className="flex flex-row items-center justify-between space-y-0 pb-2" data-id="element-492">
            <CardTitle className="text-sm font-medium" data-id="element-493">Saldo Atual</CardTitle>
            <Wallet className="h-4 w-4 text-muted-foreground" data-id="element-494" />
          </CardHeader>
          <CardContent data-id="element-495">
            <div className="text-2xl font-bold" data-id="element-496">{formatCurrency(balance)}</div>
          </CardContent>
        </Card>
        <Card data-id="element-497">
          <CardHeader className="flex flex-row items-center justify-between space-y-0 pb-2" data-id="element-498">
            <CardTitle className="text-sm font-medium" data-id="element-499">
              Receitas (Mês)
            </CardTitle>
            <ArrowUpRight className="h-4 w-4 text-emerald-500" data-id="element-500" />
          </CardHeader>
          <CardContent data-id="element-501">
            <div className="text-2xl font-bold text-emerald-500" data-id="element-502">
              {formatCurrency(income)}
            </div>
          </CardContent>
        </Card>
        <Card data-id="element-503">
          <CardHeader className="flex flex-row items-center justify-between space-y-0 pb-2" data-id="element-504">
            <CardTitle className="text-sm font-medium" data-id="element-505">
              Despesas (Mês)
            </CardTitle>
            <ArrowDownRight className="h-4 w-4 text-destructive" data-id="element-506" />
          </CardHeader>
          <CardContent data-id="element-507">
            <div className="text-2xl font-bold text-destructive" data-id="element-508">
              {formatCurrency(expense)}
            </div>
          </CardContent>
        </Card>
      </div>

      <Card className="flex-1 flex flex-col overflow-hidden" data-id="element-509">
        <CardHeader data-id="element-510">
          <CardTitle data-id="element-511">Transações Recentes</CardTitle>
        </CardHeader>
        <CardContent className="flex-1 overflow-auto p-0" data-id="element-512">
          <Table data-id="element-513">
            <TableHeader data-id="element-514">
              <TableRow data-id="element-515">
                <TableHead className="pl-6" data-id="element-516">Descrição</TableHead>
                <TableHead data-id="element-517">Categoria</TableHead>
                <TableHead data-id="element-518">Data</TableHead>
                <TableHead data-id="element-519">Status</TableHead>
                <TableHead className="text-right pr-6" data-id="element-520">Valor</TableHead>
              </TableRow>
            </TableHeader>
            <TableBody data-id="element-521">
              {mockTransactions.map(t => <TableRow key={t.id} data-id="element-522">
                  <TableCell className="pl-6 font-medium" data-id="element-523">
                    {t.description}
                  </TableCell>
                  <TableCell data-id="element-524">{t.category}</TableCell>
                  <TableCell data-id="element-525">{formatDate(t.dueDate)}</TableCell>
                  <TableCell data-id="element-526">
                    {t.status === 'paid' ? <Badge variant="outline" className="bg-emerald-500/10 text-emerald-500 border-emerald-500/20" data-id="element-527">
                        Pago
                      </Badge> : t.status === 'pending' ? <Badge variant="outline" className="bg-automotive-orange/10 text-automotive-orange border-automotive-orange/20" data-id="element-528">
                        Pendente
                      </Badge> : <Badge variant="outline" className="bg-destructive/10 text-destructive border-destructive/20" data-id="element-529">
                        Atrasado
                      </Badge>}
                  </TableCell>
                  <TableCell className={`text-right pr-6 font-medium ${t.type === 'income' ? 'text-emerald-500' : 'text-destructive'}`} data-id="element-530">
                    {t.type === 'income' ? '+' : '-'}
                    {formatCurrency(t.amount)}
                  </TableCell>
                </TableRow>)}
            </TableBody>
          </Table>
        </CardContent>
      </Card>
    </div>;
}